import React, { useEffect, useState } from "react";
import axios from "axios";
//scss
import AddCuratorStyle from "./addCurator.module.scss";

//bootstrap
import { Form, Container, Row, Col } from "react-bootstrap";

//svg
import { ReactComponent as Save } from "../../resources/svg/save.svg";

//component
import ResponsiveDrawer from "../../components/responsiveDrawer/responsiveDrawer";
import Cbtn from "../../components/commonbutton/cbtn";
import SelectLabels from "../../components/dropdowns/1/dropdown1";
import Autocomplete from "../../components/autoComplete/autoComplete";
import Snackbar from "../../components/snackbar/snackbar";
//redux
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import LoadingScreen from "../../components/loadingSpinner/loadingScreen";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../store/network routes/instance";
import { selectStatus } from "../../store/features/adminSlice";
import {
  getFranchise,
  getFreeFranchise,
  selectfranchiseData,
  selectFreeFranchiseData,
} from "../../store/features/franchiseSlice";
import { createCurator } from "../../store/features/curatorSlice";

function AddCurator() {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const [curatorDetail, setCuratorDetail] = useState({
    name: "",
    email: "",
    userId: "",
    password: "",
    image: "",
  });
  const [error, setError] = React.useState("");
  const [showError, setShowError] = React.useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [franchiseOptions, setFranchiseOptions] = useState([]);
  let franchises = useSelector(selectFreeFranchiseData);

  const sendFile = async (file) => {
    let bodyFormData = new FormData();
    setDisableSubmit(true);
    bodyFormData.append("file", file);
    try {
      if (bodyFormData.get("file")) {
        let res = await instance({
          method: "email",
          url: "uploadFile",
          data: bodyFormData,
          headers: {
            "Content-Type": "multipart/form-data; ",
          },
        });
        if (res.data.statusCode === 200) {
          setDisableSubmit(false);
          return res.data.url;
        } else {
        }
      }
    } catch (e) {
      if (e.code === "ERR_NETWORK") {
        alert("File size should be less than 50mb");
        setDisableSubmit(false);
        document.getElementById("userIdProof").value = "";
        setCuratorDetail((prev) => ({
          ...prev,
          userIdProof: "",
        }));
      }
    }
  };

  const handleChange = async (e) => {
    let res = await sendFile(e.target.files[0]);
    if (res) {
      setCuratorDetail({
        ...curatorDetail,
        image: res,
      });
    }
  };

  const handleChange1 = async (e) => {
    let res = await sendFile(e.target.files[0]);
    if (res) {
      setCuratorDetail({
        ...curatorDetail,
        userIdProof: res,
      });
    }
  };

  const handleFormChange = (e, value) => {
    setCuratorDetail({
      ...curatorDetail,
      [e.target.name]: value || e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let validate = false;

    const { name, email, userId, password } = curatorDetail;

    validate =
      Object.values({
        name,
        email,
        password,
      }).every(Boolean) ||
      Object.values({
        name,
        userId,
        password,
      }).every(Boolean);

    if (validate) {
      submitForm(curatorDetail);
    } else {
      setError("Enter Full Details");
      setShowError(true);
      validate = false;
    }
  };

  const submitForm = async (data) => {
    const res = await dispatch(createCurator(data));
    if (res.payload.statusCode === 201) {
      setCuratorDetail({
        name: "",
        email: "",
        userId: "",
        password: "",
        image: "",
      });
      navigate("/curators");
    } else if (res.payload.statusCode === 400) {
      setError(res.payload.msg);
      setShowError(true);
    }
    return res;
  };
  // console.log(curatorDetail);
  const loadingStatus = useSelector(selectStatus);

  return (
    <>
      {loadingStatus === "Loading" && <LoadingScreen />}
      {loadingStatus === "fulfilled" && (
        <ResponsiveDrawer>
          <Snackbar
            show={showError}
            setShow={setShowError}
            errorMsg={error}
            location={{ vertical: "bottom", horizontal: "center" }}
          ></Snackbar>
          <Container className={AddCuratorStyle.container}>
            <Row className={AddCuratorStyle.Container}>
              <Col>
                <h1 className={AddCuratorStyle.mainHeading}>Add Curators</h1>
              </Col>
            </Row>
            <Row
              className={`${AddCuratorStyle.Container} ${AddCuratorStyle.formContainer}`}
            >
              <Form onSubmit={handleSubmit}>
                {/* <Row>
                  <Col>
                    <input
                      type="file"
                      className={AddCuratorStyle.customFileInput}
                      accept="image/*"
                      onChange={handleChange}
                    />
                    <div
                      style={{
                        background: curatorDetail.image
                          ? `url(${curatorDetail.image}) #CBCBCB center center/cover`
                          : "#CBCBCB",
                        height: "110px",
                        width: "110px",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "-60px",
                        right: "70px",
                        zIndex: 2,
                      }}
                    />
                  </Col>
                </Row> */}
                <Row>
                  <Form.Group as={Col} className="mb-4" controlId="name">
                    <Form.Label className={AddCuratorStyle.label}>
                      Name
                    </Form.Label>
                    <Form.Control
                      className={AddCuratorStyle.control}
                      type="name"
                      name="name"
                      onChange={handleFormChange}
                      placeholder="name"
                      value={curatorDetail.name}
                    />
                  </Form.Group>
                  <Form.Group as={Col} className="mb-4" controlId="userId">
                    <Form.Label className={AddCuratorStyle.label}>
                      Username
                    </Form.Label>
                    <Form.Control
                      // id={""}
                      className={AddCuratorStyle.control}
                      type="text"
                      name="userId"
                      placeholder="username"
                      onChange={handleFormChange}
                      // value={curatorDetail.userId}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} className="mb-4" controlId="email">
                    <Form.Label className={AddCuratorStyle.label}>
                      Email
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="John Doe"
                      name="email"
                      className={AddCuratorStyle.control}
                      value={curatorDetail.email}
                      onChange={handleFormChange}
                    />
                  </Form.Group>

                  <Form.Group as={Col} className="mb-4" controlId="password">
                    <Form.Label className={AddCuratorStyle.label}>
                      Password
                    </Form.Label>
                    <Form.Control
                      className={AddCuratorStyle.control}
                      type="password"
                      name="password"
                      onChange={handleFormChange}
                      value={curatorDetail.password}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Col xl={6}>
                    <Cbtn
                      disabled={disableSubmit}
                      type="submit"
                      style={{
                        fontSize: "0.8rem",
                        backgroundColor: disableSubmit ? "grey" : "#0040A8",
                        color: disableSubmit ? "black" : "#fff",
                        margin: "auto",
                        float: "right",
                        borderRadius: "10px ",
                        width: "8rem",
                        fontFamily: "IBMPlexSans-SemiBold",
                        letterSpacing: "0px",
                        padding: "11px 34px",
                      }}
                    >
                      <Save
                        style={{ marginRight: "5px" }}
                        className={AddCuratorStyle.save}
                      />
                      Save
                    </Cbtn>
                  </Col>
                  <Col xl={6}>
                    <Cbtn
                      to="/curators"
                      disabled={disableSubmit}
                      type="button"
                      style={{
                        backgroundColor: "#363B64",
                        color: "white",
                        margin: "auto",
                        fontSize: "0.8rem",
                        borderRadius: "10px ",
                        width: "8rem",
                        fontFamily: "IBMPlexSans-SemiBold",
                        letterSpacing: "0px",
                      }}
                    >
                      Discard
                    </Cbtn>
                  </Col>
                </Row>
              </Form>
            </Row>
          </Container>
        </ResponsiveDrawer>
      )}
    </>
  );
}

export default AddCurator;
